import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

export const BUTTON_MESSAGE_WIDTH = 370

const useStyles = makeStyles({
	showLinkButton: {
		textTransform: "none",
		fontWeight: "normal",
		fontSize: 14,
		"&:hover": {
			textDecoration: "none"
		},
		"& span": {
			display: "flex",
			alignItems: "center",
			justifyContent: "center"
		}
	},
	button: {
		boxShadow: `0px 1px 1px ${colors.gray[300]}`,
		borderRadius: "8px",
		fontWeight: "normal",
		fontSize: 14,
		textTransform: "none"
	},
	buttonText: {
		textOverflow: "ellipsis",
		whiteSpace: "pre-wrap",
		overflow: "hidden",
		maxWidth: "100%",
		WebkitBoxOrient: "vertical",
		WebkitLineClamp: 1,
		flex: 1
	}
})

export default useStyles
